import { useDateFilter } from '../contexts/DateFilterContext';
import { tr } from '../lib/i18nHelpers';

// 2026-10-22 spec §5.5 — the FY context existed but no picker rendered it. Reports
// (and Workflow Step 5) read useDateFilter() and honor this selection automatically.
export default function FiscalYearSelect() {
  const { selectedFY, fyOptions, setSelectedFY } = useDateFilter();
  if (!fyOptions || fyOptions.length === 0) return null;
  return (
    <div className="px-3 pb-3">
      <label className="mb-1 block text-xs font-medium text-muted-foreground">
        {tr('Financial Year', '財政年度', '财政年度')}
      </label>
      <select
        value={selectedFY}
        onChange={e => setSelectedFY(e.target.value)}
        aria-label={tr('Financial Year', '財政年度', '财政年度')}
        className="w-full min-w-0 rounded-lg border px-3 py-2 text-xs text-foreground bg-card focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {fyOptions.map(o => (
          <option key={o.value} value={o.value}>
            {`FY ${o.label}`}
          </option>
        ))}
      </select>
    </div>
  );
}
